export const selectTestingAnalyticsDetailedState = (state) =>
  state.testingAnalyticsDetailed || {};

export const selectTableData = (state) =>
  selectTestingAnalyticsDetailedState(state).detailedData || [];

export const selectLoading = (state) =>
  selectTestingAnalyticsDetailedState(state).loading || false;

export const selectError = (state) =>
  selectTestingAnalyticsDetailedState(state).error;

export const selectPagination = (state) =>
  selectTestingAnalyticsDetailedState(state).pagination || { currentPage: 1, pageSize: 10, total: 0 };